import axios from 'axios'
import _ from 'lodash'

const state = {
  workSpaces: [],
  modifiedWorkSchedules: {},
}

const getters = {
  getWorkSpacesDayData (state) {
    return state.workSpaces
  },

  getModifiedWorkSchedules (state) {
    const data = _.toArray(state.modifiedWorkSchedules)
    return _.reject(data, (item) => {
      return _.isNull(item.userId) && _.isNull(item.workScheduleId)
    })
  },

  canSaveChanges (state, getters) {
    return getters.getModifiedWorkSchedules.length > 0 &&
      getters.getModifiedWorkSchedules.filter((item) => item.hasError).length === 0
  },
}

const mutations = {
  setWorkSpaces (state, data) {
    state.workSpaces = data
  },
  resetWorkSpaces (state) {
    state.workSpaces = []
    state.modifiedWorkSchedules = []
  },
  resetModifiedWorkSchedule (state) {
    state.modifiedWorkSchedules = []
  },

  addModifiedWorkSchedule (state, data) {
    const items = state.modifiedWorkSchedules
    items[data.key] = data
    state.modifiedWorkSchedules = { ...items }
  },

  showWorkSpaceFromReserve (state, groupKey) {
    const items = state.workSpaces
    for (let i = 0; i < items[groupKey].workSpaces.length; ++i) {
      if (items[groupKey].workSpaces[i].isReserve) {
        items[groupKey].workSpaces[i].isReserve = false
        break
      }
    }
    state.workSpaces = items
  },
}

const actions = {
  fetchWorkSpacesFullData ({ rootGetters, commit, dispatch }, params) {
    params = params || {
      clear: false,
    }
    if (params.clear) {
      commit('resetWorkSpaces')
    }

    const meta = {}
    meta.filialId = params.filialId || rootGetters['branches/getGlobalFilialId']
    meta.date = params.date || rootGetters['orders/getSelectedDate']

    /* Make unique request, other pending will be canceled */
    const url = rootGetters['api/fetchWorkSchedulesDayData']
    const source = axios.CancelToken.source()
    dispatch('requests/addUniqueRequest', { url, source }, { root: true })
    return axios
      .get(url, {
        params: meta,
        cancelToken: source.token,
      })
      .then(res => {
        commit('resetWorkSpaces')
        commit('setWorkSpaces', res.data.items)
        return res.data.items
      })
  },

  saveModifiedWorkSchedules ({ rootGetters, getters, dispatch }) {
    const data = {
      filialId: rootGetters['branches/getGlobalFilialId'],
      date: rootGetters['orders/getSelectedDate'],
      workSchedules: getters.getModifiedWorkSchedules,
    }

    return axios
      .post(rootGetters['api/updateWorkDay'], data)
      .then(res => {
        return dispatch('fetchWorkSpacesFullData', { clear: false })
      })
  },

  startWorkScheduleTransfer ({ rootGetters, dispatch }, data) {
    data.date = rootGetters['orders/getSelectedDate']

    return axios
      .post(rootGetters['api/startWorkScheduleTransfer'], data)
      .then(() => {
        return dispatch('fetchWorkSpacesFullData', { clear: false })
      })
  },

  completeWorkScheduleTransfer ({ rootGetters, dispatch }, { id }) {
    console.log(id)
    return axios
      .post(rootGetters['api/completeWorkScheduleTransfer'](id))
      .then(() => {
        return dispatch('fetchWorkSpacesFullData', { clear: false })
      })
  },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
